<div>
  <h2 class="rounded rounded-2 text-center">Follow-up Assessment Details</h2>
  <p><strong>Centre Name:</strong> {{ assessmentData.centreName }}</p>
  <p><strong>Session Type:</strong> {{ assessmentData.sessionType }}</p>
  <p><strong>Date of Assessment:</strong> {{ assessmentData.dateOfAssessment.toDate() | date: 'dd/MM/yyyy' }}</p>
  <p><strong>Child Name:</strong> {{ assessmentData.childName }}</p>
  <p><strong>Submitted By:</strong> {{ assessmentData.submittedBy }}</p>
  <div>
    <h3 class="rounded rounded-2 text-center">Questions</h3>
    <div class="row">
      <div class="col-md-6">
    <div *ngFor="let question of assessmentData.questions; let i = index">
      <div  class="list-group-item list-group-item-secondary mb-2 rounded bg-light text-dark">
        <p ><strong>{{ i + 1 }}. {{ question.question }}</strong></p>
        <p ><strong >Answer:  </strong> <span class="btn bg-warning text-dark rounded-pill">{{ question.ans }} </span></p>
        <p><strong>Remark:</strong> {{ question.remark }}</p>
      </div>
    </div>
  </div>
      <div class="col-md-6">
        <div class="col-md-6">
          <canvas baseChart
                  [labels]="doughnutChartLabels"
                  [datasets]="chartconfigurationsArray[0]"
                  [options]="doughnutChartOptions"
                  [legend]="true"
                  [type]="'doughnut'" >
          </canvas>&nbsp;
          <h3>
            Total Not Able to Coping up {{totalYes}} <br>
            Total Able to Coping up {{totalNo}} <br>
            Total Difficulty in Coping up {{totalSometimes}}
          </h3>

        </div>
      </div>
  </div>
  </div>

</div>
